import { render, staticRenderFns } from "./langtest_edit.vue?vue&type=template&id=855e82b8&scoped=true&"
import script from "./langtest_edit.vue?vue&type=script&lang=js&"
export * from "./langtest_edit.vue?vue&type=script&lang=js&"
import style0 from "./langtest_edit.vue?vue&type=style&index=0&id=855e82b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855e82b8",
  null
  
)

export default component.exports